// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"5858":"9d53255e8fbafae14bd1","6991":"6fa52e9c506e3fc5ac63","8706":"42f07f65229d6351d242"}[chunkId] + ".js";
};